<template>
  <a
    href="https://wa.me/79645680103"
    target="_blank"
    class="c-call__outer"
    data-stickyeah-offset="120"
  >
    <div class="c-call">
      <img
        src="@/projects/people/assets/img/call/call.svg"
        alt=""
      />
    </div>
    <img
      src="@/projects/people/assets/img/call/call-mobile.svg"
      class="c-call__mobile"
      alt=""
    />
  </a>
</template>

<style lang="scss">
@import "./TheCall.scss";
</style>
